class Tag
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'tag--bound'
            @.$el.classList.add 'tag--bound'
            @.InitEvents()
        return   

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            self.$el.classList.toggle 'tag--active'
            window.dispatchEvent new CustomEvent 'tagactivechange', { 
                bubble: true, 
                detail: { 
                    tagId: self.$el.dataset.tagId,
                    active: !self.$el.classList.contains('tag--active')
                } 
            }
            return
        return

BindTags = ->
    document.querySelectorAll '.tag:not(.tag--bound)'
        .forEach (el) ->
            new Tag el
            return
    return

window.addEventListener 'bind-components', BindTags